import { render, staticRenderFns } from "./AddRoles.vue?vue&type=template&id=28ad8347&"
import script from "./AddRoles.vue?vue&type=script&lang=js&"
export * from "./AddRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports